<template>
    <span>
        <v-list-tile @click.stop="$emit('eventoAbrirModalSolicitarReadequacao')">
            <v-list-tile-title>
                Readequação | Doc. Complementar
            </v-list-tile-title>
        </v-list-tile>
    </span>
</template>

<script>
export default {
    name: 'AcoesSolicitarReadequacao'
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .botao-primario
        padding 0 25px
        border 1px solid var(--v-primary-base)
        background-color var(--v-primary-base) !important
        color #fff !important
        box-sizing border-box
        margin-left 15px !important
</style>